import ServicesAccordion from "./ServicesAccordion";
import ExpertCounter from "../amirComponents/amirCounter/ExpertCounter";
import {Section5} from "../../types/home"
import { Section7 } from "../../types/department";

const video = "https://goodhand.b-cdn.net/Assets/goodhand_homepage.mp4";

interface Props {
  section5?: Section5;
  section6?: Section7
}

const Services: React.FC<Props> = ({ section5, section6 }) => {
  return (
    <div>
      <section className="service-wrap ">
        <div className="container ">
          <div className="row">
            <div className="col-md-6">
              <div className="hd-style-2 text-white wow animate__fadeInLeft">
                <h2
                  dangerouslySetInnerHTML={{
                    __html: section5?.heading ?? "",
                  }}
                ></h2>
                <p
                  className="text-justify text-white"
                  dangerouslySetInnerHTML={{
                    __html: section5?.line ?? "",
                  }}
                ></p>
              </div>
            </div>

            <ServicesAccordion jsonData={section5?.box} />
          </div>
        </div>
      </section>

      <section>
        <ExpertCounter section7={section6} />
      </section>

      <section className="stars">
        <div className="container">
          <div className="row justify-content-center video_sertion">
            <div className="col-12 col-md-12 col-lg-12 py-2 position-relative">
              <div className="video-container">
                <video
                  width="100%"
                  height="240"
                  autoPlay
                  loop
                  muted
                  playsInline
                  controlsList="nodownload nofullscreen noremoteplayback"
                >
                  <source src={video} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Services;
